import { render, staticRenderFns } from "./DefaultHeaderDropdownAccnt.vue?vue&type=template&id=f5ff5c40"
import script from "./DefaultHeaderDropdownAccnt.vue?vue&type=script&lang=js"
export * from "./DefaultHeaderDropdownAccnt.vue?vue&type=script&lang=js"
import style0 from "./DefaultHeaderDropdownAccnt.vue?vue&type=style&index=0&id=f5ff5c40&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports